import { config } from '../config';
import { HttpServices } from '../Helper';

export const GetGeneratedProposals = async (data) => {
  return await HttpServices.post(
    `${config.server_address}/CrmDfm/SmartProposal/GetMyGeneratedProposals`,
    data
  );
};
export const ShareGeneratedProposal = async (data) => {
  return await HttpServices.post(
    `${config.server_address}/CrmDfm/SmartProposal/ShareGeneratedProposal`,
    data
  );
};
export const AddSmartProposalLog = async (body) => {
  return await HttpServices.post(
    `${config.server_address}/CrmDfm/SmartProposal/AddSmartProposalLog`,
    body
  );
};

export const GetSmartProposalLogs = async (body) => {
  return await HttpServices.post(
    `${config.server_address}/CrmDfm/SmartProposal/GetSmartProposalLogs`,
    body
  );
};
